module.exports = __webpack_public_path__ + "static/media/impl_diagram.d7ec6368.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Implementation/img/impl_diagram.png
// module id = 288
// module chunks = 0